export { default } from "./openHousesSlice";
export * from "./openHousesSlice";
